import React from 'react';
const quotes = ['¿Me lo mandas? Lo necesito.', '¿Cuánto cuesta? ¿Cómo lo compro?', 'Por fin algo que sí entiendo y sí puedo hacer.'];
export function TrustCTA() {
  return <section className="py-8 px-6 bg-[#FFFBE6]" data-id="element-273">
      <div className="max-w-xl mx-auto" data-id="element-274">
        {/* Header */}
        <div className="text-center mb-5" data-id="element-275">
          <h2 className="text-xl md:text-2xl font-bold text-[#222222] mb-1" data-id="element-276">
            Lo que vas a empezar a escuchar
          </h2>
          <p className="text-sm text-gray-500 italic" data-id="element-277">(cuando lo publiques)</p>
        </div>

        {/* Quote Cards */}
        <div className="space-y-2" data-id="element-278">
          {quotes.map((quote, index) => <div key={index} className="bg-white rounded-xl p-3 text-center" style={{
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)'
        }} data-id="element-279">
              <p className="text-[#333333] text-[15px] font-medium" data-id="element-280">
                "{quote}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}